export default __webpack_public_path__ + "media/images/banner/banner-9-064c4571831fbb68d93a78fb116d9cc2.jpg";